// extracted by mini-css-extract-plugin
export default {"termsLabel":"go3vWYzVE7cyQpcKNBli"};